export default __webpack_public_path__ + "8c3626b901d79de19b6946539d84c6ce.png";